export const EXTERNAL_LINK = {
  appleAppStore: 'https://apps.apple.com/nz/app/coachmate-sport/id1600141276',
  googlePlayStore: 'https://play.google.com/store/apps/details?id=sport.coachmate',
  helpCenter: 'https://coachmate.freshdesk.com/support/home',
  privacyPolicy: 'https://www.coachmate.sport/privacy-policy',
  termsOfUse: 'https://www.coachmate.sport/terms-of-use',
}
